export default __webpack_public_path__ + "static/media/laminas.94457338.jpeg";